import { formatHtml } from "@trumpf/ux.common-storybook";
import { TeaserVideoTemplate, dummyVideo } from "./teaser-video.templates";

export default {
    title: "Website/Partial Templates/Teaser/Video",
    render: TeaserVideoTemplate.bind({}),
    tags: ["autodocs"],
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: { ...dummyVideo },
};

export const Default = {};
